import React from 'react';

export type Data = { [key: string]: string };
export interface ILogger {
  logVerbose(message: string, additionalData?: Data): void;
  logInfo(message: string, additionalData?: Data): void;
  logWarning(message: string, additionalData?: Data): void;
  logError(message: string, additionalData?: Data): void;
  clone(): ILogger;
  setAppendedData(key: string, value: string): void;
}

const LoggerContext = React.createContext<ILogger>({
  logVerbose: console.debug,
  logInfo: console.info,
  logWarning: console.warn,
  logError: console.error,
  clone: () => {
    throw new Error('Not implemented');
  },
  setAppendedData: () => {},
});

export const useLogger: () => ILogger = () => React.useContext(LoggerContext);

export const LoggerProvider = LoggerContext.Provider;
